import { ReactNode, useEffect} from "react";
import { useToast, ToastContext, ToastType } from "./customHooks"
import { globalErrorHandler, GlobalError } from "./globalErrorHandler";

const errorTypeToToastType = (type: GlobalError['type']): ToastType => {
  switch (type) {
    case 'error': return 'failure';
    case 'warning': return 'info';
    case 'info': return 'info';
  }
};

export function ToastProvider({ children }: { children: ReactNode }) {
  const toast = useToast();

  // Subscribe to global errors from non-React code (e.g., axios interceptors)
  useEffect(() => {
    const unsubscribe = globalErrorHandler.subscribe((error) => {
      toast.showToast({
        toastType: errorTypeToToastType(error.type),
        title: error.title,
        message: error.message,
        autoDisappearTimeInSeconds: error.autoDisappear
      });
    });

    return unsubscribe;
  }, [toast]);

  return (
    <ToastContext.Provider value={toast}>
      {children}
    </ToastContext.Provider>
  );
}

